import { makeStyles } from '@material-ui/core';
import React, { FC } from 'react';

const FONT_WEIGHT_ENUM: any = {
  300: 'Light',
  400: 'Regular',
  500: 'Medium',
  600: 'SemiBold',
  700: 'Bold',
  800: 'Custom'
};

const useStyles = makeStyles(() => ({
  wrapper: {
    padding: '1rem',
    border: '1px solid #D9D9D9',

    display: 'flex',
    flexDirection: 'column',
    gap: '1rem',
    maxHeight: '17rem',
    overflowY: 'scroll'
  },

  boxWrapper: {
    display: 'flex',
    flexDirection: 'column',
    gap: '1rem'
  },
  roundWrapper: {
    width: '1.25rem',
    height: '1.25rem',
    padding: '0.15625rem',
    borderRadius: 999,
    border: '1px solid #000'
  },
  round: {
    width: '100%',
    height: '100%',
    borderRadius: 999,
    backgroundColor: '#000'
  },
  fontWrapper: {
    cursor: 'pointer',
    display: 'flex',
    gap: '0.5rem'
  }
}));

const FontFamilyPicker: FC<any> = ({
  oriFontFamily,
  oriFontWeight,
  handleFontFamily
}: any) => {
  const classes = useStyles();
  let Font;
  const myFont = JSON.parse(localStorage.getItem('fontFiles'));
  const FONT_FAMILY: any = ['Roboto', 'Inter', 'Montserrat', 'Poppins'];
  if (myFont) {
    const myFontNames = myFont.map(font => font.name);
    Font = [...myFontNames, ...FONT_FAMILY];
  } else {
    Font = FONT_FAMILY;
  }
  return (
    <div className={classes.wrapper}>
      {Font.map((fontFamily: string, idx: number) => {
        let fontWeights;
        if (['Roboto', 'Inter', 'Montserrat', 'Poppins'].includes(fontFamily)) {
          fontWeights = [300, 400, 500, 600, 700];
        } else {
          fontWeights = [800];
        }
        return (
          <div key={idx} className={classes.boxWrapper}>
            {fontWeights.map((fontWeight: number, idx2: number) => {
              return (
                <div
                  key={idx2}
                  className={classes.fontWrapper}
                  onClick={() => handleFontFamily(fontFamily, fontWeight)}
                >
                  <div className={classes.roundWrapper}>
                    {oriFontFamily === fontFamily &&
                      oriFontWeight === fontWeight && (
                        <div className={classes.round} />
                      )}
                  </div>
                  <span>
                    {`${fontFamily} [${FONT_WEIGHT_ENUM[fontWeight]}]`}
                  </span>
                </div>
              );
            })}
          </div>
        );
      })}
    </div>
  );
};

export default FontFamilyPicker;
